// import { createStore, applyMiddleware, combineReducers } from "redux";
// import thunk from "redux-thunk";
// import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage";

import reducer from "./reducer";

// const Store = () => {
//   const persistConfig = {
//     key: "root",
//     storage: storage,
//   };

//   const pertReducer = persistReducer(
//     persistConfig,
//     combineReducers({ general: reducer })
//   );
//   const middleWare = applyMiddleware(thunk);
//   const store = createStore(pertReducer, middleWare);
//   let persistor = persistStore(store);

//   return { store, persistor };
// };

// export default Store;

import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

const Store = () => {
  const persistConfig = {
    key: "root",
    storage: storage,
    whitelist: ["general", "categories"],
  };
  const pertReducer = persistReducer(
    persistConfig,
    combineReducers({ general: reducer })
  );
  const middleWare = applyMiddleware(thunk);
  return createStore(pertReducer, middleWare);
};

export default Store;



// WEBPACK FOOTER //
// ./src/redux/store.js